import { type FC } from 'react';
import { useHistory } from 'react-router-dom';
import { DiscoverProgramCard } from '@rivallapp/volosports-components';

interface DiscoverCardProps {
  /** used for all programs except drop-ins */
  programId?: string;
  /** only used for drop-in programs */
  gameId?: string;
  /** value from Discover toggle */
  shouldSeePricesWithFees: boolean;
}

/** @description Wrapped SCL DiscoverProgramCard. Currently only in use for Daily programs, but is compatible with all program types */
const DiscoverCard: FC<DiscoverCardProps> = ({ programId, gameId, shouldSeePricesWithFees }) => {
  const history = useHistory();

  const onCardPress = ({ programId, gameId }: Pick<DiscoverCardProps, 'programId' | 'gameId'>) => {
    const link = programId ? `/d/${programId}` : `/game/${gameId}`;
    history.push(link);
  };

  return (
    <DiscoverProgramCard
      programId={programId}
      gameId={gameId}
      shouldSeePricesWithFees={shouldSeePricesWithFees}
      onCardPress={() => onCardPress({ programId, gameId })}
    />
  );
};

export default DiscoverCard;
